import React, { useState, useRef, useEffect } from 'react';
import { Modal } from 'antd';
import TimeSeriesMenu from './TimeSeriesMenu';
import { handleTSA } from 'utils/rightBarButtonsFunctionalities';
import homeService from 'services/homeService';
import fileRecognize from 'utils/fileType';
import { useNotificationHandler } from 'hooks/useNotificationHandler';
import L from 'leaflet';

import "assets/styles/Home/HomeUI/TimeSeries/time-series-animation.css";

const API_URL = process.env.REACT_APP_API_URL;

const TimeSeriesAnimation = ({ mapRef, setIsTSAButtonClicked }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [videoURL, setVideoURL] = useState(null);
    const [selectedResolutions, setSelectedResolutions] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);

    const {
        notifySuccess,
        notifyError,
        notifyLoading,
        closeNotification,
        contextHolder
    } = useNotificationHandler();

    async function submitQueryAnimation(startDate, endDate, selectedResolutions, mapRef, bbox) {
        setVideoURL(null);
        setLoading(true);

        const loadingKey = notifyLoading(
            'Loading Animation',
            'Sit Back and Relax while we generate your animation...',
            0
        );

        
        const bbox_3857 = {
            southWest: L.CRS.EPSG3857.project(bbox.southWest),
            northEast: L.CRS.EPSG3857.project(bbox.northEast) 
        };

        const layer = Object.keys(selectedResolutions)[0];
        const spaceResolution = selectedResolutions[layer].space;
        const timeResolution = selectedResolutions[layer].time;

        try {
            const file = fileRecognize(layer);
            const fileName = file.fileName;
            const provider = file.provider;

            const returnedData = await homeService.getAnimation(
                spaceResolution,
                timeResolution,
                startDate,
                endDate,
                provider,
                mapRef,
                bbox_3857,
                fileName
            );

            const videoURL = API_URL + returnedData.video_url;

            setVideoURL(videoURL);
            setIsModalVisible(true);

            closeNotification(loadingKey);
            notifySuccess("Animation Loaded", "Animation generated successfully");

        } catch (error) {
            console.error(`Error fetching animation for ${layer}:`, error);

            closeNotification(loadingKey);
            notifyError(
                "Animation Failed",
                `Error fetching animation for ${layer}. Please try again.`
            );
        } finally {
            setLoading(false);
        }
    }

    const handleVideoError = () => {
        notifyError(
            "Video Error",
            "There was a problem playing the animation. Please try again."
        );
    };

    return (
        <div className='container-tsa'>
            {contextHolder}

            <TimeSeriesMenu
                type={'anim'}
                selectedResolutions={selectedResolutions}
                setSelectedResolutions={setSelectedResolutions}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                loading={loading}
                submitQuery={submitQueryAnimation}
                handleFunction={handleTSA}
                setIsButtonClicked={setIsTSAButtonClicked}
                mapRef={mapRef}
            />
            

            <Modal
                title="Time Series Animation"
                open={isModalVisible}
                footer={null}
                onCancel={() => {
                    setIsModalVisible(false);
                    setVideoURL(null);
                }}
                centered
                width="55%"
                styles={{
                    body: {
                        padding: 0,
                        maxHeight: '80vh',
                        height: 'auto',
                        width: '100%',
                        maxWidth: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                        position: 'relative'
                    } 
                }}
                zIndex={1500}
            >
                {
                    videoURL ? (
                        <div className="relative w-full h-full max-h-[70vh] flex justify-center items-center">
                            <video
                                src={videoURL}
                                controls
                                autoPlay
                                className="w-full h-full object-contain"
                                onError={handleVideoError}
                            />
                        </div>
                    ) : (
                        <div className="flex items-center justify-center w-full h-full">
                            <p className="text-lg">Loading video...</p>
                        </div>
                    )
                }
            </Modal>
        </div>
    );
}

export default TimeSeriesAnimation;